<!-- src/pages/MyPage.vue -->
<script setup>
import IconCheck03 from '@/components/svg/IconCheck03.vue';
import { computed } from 'vue';

definePage({ meta: { layout: 'purchase' } });

const router = useRouter();
const route = useRoute();

const errorMessage = computed(() => {
  return route.query.message ? decodeURIComponent(route.query.message) : '';
});

const handleSubmit = () => {
  const path = '/purchase/points';
  router.push(path);
};

const goService = () => {
  router.push('/mypage/history');
};
</script>

<template>
  <div class="my-info-wrap purchase-finish-page">
    <div class="my-tit-box com-bg-my-box h-small">
      <div class="tit">포인트 충전</div>
      <div class="path">
        <ul>
          <li>홈</li>
          <li>마이페이지</li>
          <li>낭만 저장소</li>
          <li>포인트 충전</li>
        </ul>
      </div>
    </div>
    <div class="myinfo-box com-bg-my-box">
      <div class="finish-box">
        <div class="com-btn-box">
          <i class="icon-check03"><IconCheck03 /> </i>
        </div>
        <div class="gap-xxl"></div>
        <div class="fnt-big">낭만 포인트 충전이<br />실패되었습니다</div>
        <div class="fnt-fail-msg">{{ errorMessage }}</div>
        <div class="fnt-small">
          동일한 문제가 지속적으로 발생할 경우, <br />해당 서비스 관리자에게 문의해 주세요.
        </div>
        <div class="gap-xxl"></div>
        <div class="com-btn-box">
          <VBtn type="submit" style="width: 260px" @click="handleSubmit">
            포인트 충전 다시하기
          </VBtn>
        </div>
        <!-- <div class="gap-xxl"></div>  -->
      </div>
    </div>
    <div class="payment-end-msg-box">
      결제 완료된 내역은 이용중인 서비스에서 확인할 수 있습니다.
      <button class="btn-txt-line" @click="goService()">이용중인 서비스 바로가기</button>
    </div>
  </div>
</template>
<style>
.fnt-big {
  text-align: center;
}
.fnt-small {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--Gray-700, #575757);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.fnt-fail-msg {
  padding-top: 8px;
  color: var(--orange-300-main, #eb4c10);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  margin-bottom: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

@media (max-width: 768px) {
  .purchase-finish-page {
    width: 100vw;
    margin-bottom: 0;
  }
  .purchase-finish-page .my-tit-box {
    display: none;
  }
  .purchase-finish-page .myinfo-box.com-bg-my-box {
    margin-bottom: 0;
    border-radius: 0;
    padding: 0;
  }
  .purchase-finish-page .finish-box {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 48px 20px 36px;
  }
  .purchase-finish-page .finish-box .com-btn-box .v-btn {
    width: 100% !important;
  }
  .purchase-finish-page .payment-end-msg-box {
    flex-direction: column;
    gap: 6px;
    margin-top: 0;
    padding: 16px 20px 24px;
    text-align: center;
    line-height: 20px;
    font-size: 13px;
  }
  .purchase-finish-page .payment-end-msg-box .btn-txt-line {
    margin-left: 0;
  }
}
</style>
